module.exports = __webpack_public_path__ + "img/banner4-1.8281888d.png";